export interface Segment {
  start: number;
  end: number;
}

export function exclude(segments: Segment[], takeouts: Segment[]): void {
  takeouts.forEach((takeout) => { // O(n^2) for now. Consider sort them to optimize if necessary
    segments.forEach((input, indexin) => {
      if (takeout.start <= input.start && takeout.end >= input.end) { // input within takeout
        segments.splice(indexin, 1);
      } else if (takeout.start > input.start && takeout.end < input.end) { // takout within input
        const newsegment = { ...input };
        input.end = takeout.start;
        newsegment.start = takeout.end;
        segments.push(newsegment);
      } else if (takeout.start <= input.end && takeout.end >= input.end) { // overlapping 1
        input.end = takeout.start;
      } else if (takeout.start <= input.start && takeout.end >= input.start) { // overlapping 2
        input.start = takeout.end;
      }
    });
  });
}

export function intersect(A: Segment[], B: Segment[]): Segment[] {
  const result: Segment[] = [];
  A.forEach((a) => { // O(n^2) for now. Consider sort them to optimize if necessary
    B.forEach((b) => {
      const overlap = segmentOverlap(a, b);
      if (overlap) {
        result.push(overlap);
      }
    });
  });

  return result;
}

export function segmentOverlap(a: Segment, b: Segment): Segment | null {
  if (a.start >= b.start && a.end <= b.end) { // a within b
    return a;
  } else if (b.start >= a.start && b.end <= a.end) { // b within a
    return b;
  } else if (a.start <= b.start && a.end <= b.end && b.start <= a.end) { // a start before b but ends within b
    return { start: b.start, end: a.end };
  } else if (b.start <= a.start && b.end <= a.end && a.start <= b.end) { // b start before a but ends within a
    return {start: a.start, end: b.end};
  }
  return null;
}
